'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackerPropertiesSchema = exports.configSchema = undefined;

var _messages = require('../common/messages');

var _schema = require('../common/schema');

var schema = _interopRequireWildcard(_schema);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var configSchema = exports.configSchema = schema.create('config option', _messages.configError, {
  events: {
    types: ['object']
  },
  properties: {
    types: ['object']
  },
  debug: {
    types: ['boolean', 'function']
  },
  onError: {
    types: ['function']
  },
  bypassPool: {
    types: ['boolean'],
    default: false
  },
  isBeforeUnload: {
    types: ['boolean'],
    default: false
  },
  isExternalHost: {
    types: ['boolean'],
    default: false
  },
  lastKnownEventProperties: {
    types: ['array'],
    default: []
  },
  preserveTrackerProperties: {
    types: ['boolean'],
    default: true
  }
});

var trackerPropertiesSchema = exports.trackerPropertiesSchema = schema.create('tracker properties', _messages.configError, {
  namespace: {
    types: ['string']
  },
  email: {
    types: ['string', 'function', 'object']
  },
  hubId: {
    types: ['number', 'function', 'object']
  },
  hstc: {
    types: ['string', 'function', 'object']
  },
  lang: {
    types: ['string', 'function', 'object']
  }
}, false);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.104/js/tracker/schemas.js
// module id = 1254
// module chunks = 3